import entityReducers from "./reducers";

export { entityReducers };

export default entityReducers;



// WEBPACK FOOTER //
// ./src/modules/entities/index.js